import React, { useState } from 'react'
import styled, { css } from 'styled-components'

import Box from '@components/Box'

import { above } from '@styles/mixins/breakpoints'
import { IValues } from './types'
import { defaultValues } from './data'
import Control from './Control'
import Result from './Result'
import { STypographyDesc } from '@components/Typography'

export const SCalc = styled.div`
  margin-bottom: 24px;

  ${above('md')(css`
    border: 1px solid ${({ theme }) => theme.colors.lightGray};
    box-shadow: ${({ theme }) => theme.general.boxShadow};
    border-radius: 8px;
    padding: 44px 52px;
  `)}

  ${above('xl')(css`
    display: flex;
    padding: 20px 52px;
  `)}
`

export const SDevider = styled.div`
  margin: 52px 0 32px 0;
  flex-grow: 0;
  flex-shrink: 0;
  border-top: 1px solid ${({ theme }) => theme.colors.steelGray};

  ${above('xl')(css`
    margin: 0 52px;
    width: 1px;
    min-height: 100%;
    border-top: none;
    border-right: 1px solid ${({ theme }) => theme.colors.steelGray};
  `)}
`

const Calc: React.FC<{ scrollToForm: () => void }> = ({ scrollToForm }) => {
  const [values, setValues] = useState<IValues>(defaultValues)
  return (
    <Box>
      <SCalc>
        <Box width={{ _: '100%', xl: '375px' }} py={{ _: '0', xl: '20px' }} flexGrow={0} flexShrink={0}>
          <Control values={values} onChange={setValues} />
        </Box>
        <SDevider />
        <Box width="100%" py={{ _: '0', xl: '20px' }}>
          <Result {...values} scrollToForm={scrollToForm} />
        </Box>
      </SCalc>
      <STypographyDesc mb="24px" color="darkGray">
        Не является офертой. Результаты инвестирования в прошлом не определяют доходов в будущем. В расчетах применяется
        доходность в размере 7%
      </STypographyDesc>
    </Box>
  )
}

export default Calc
